import React from "react"
import {connect} from "react-redux"

import {withTranslation} from "react-i18next"

import history from "~/history.js"
import ComponentWithData from "~/utils/ComponentWithData"
import ShelfApi from "~/utils/ShelfApi.js"
import {Article} from "~/utils/ShelfEntities"

import {Button, Field, SelectField} from "~/components/"

class ArticleStockOutView extends ComponentWithData {
  constructor(props) {
    super(props)

    this.state = {
      quantity: 1,
      destinations: [],
      selectedDestinationId: null,
      selectedSourceLocationId: null,
      sourceLocations: [],
      note: null
    }
  }

  getDestinations = () => {
    ShelfApi.get("/destinations")
      .then(response =>
        this.setState({
          destinations: response.data,
          selectedDestinationId: response.data[0].id
        })
      )
      .catch(err => {
        console.log("Error loading data: " + err)
      })
  }

  getData() {
    this.getDestinations()
    return Article.find(this.props.match.params.article_barcode)
  }

  renderLoading() {
    return <p>{this.props.t("loading")}</p>
  }

  renderError() {
    return (
      <p>
        {this.props.t("error")} {this.state.error}
      </p>
    )
  }

  renderEmpty() {
    return <p>{this.props.t("articles.detail.notFound")}</p>
  }

  renderWithData() {
    const {barcode, product, stocks, is_singular_item} = this.state.data

    const getDestination = () => {
      if (
        stocks.some(
          stock =>
            stock.storage_place && stock.storage_place.type === "Location"
        )
      ) {
        return this.state.destinations.find(
          d => d.id === this.state.selectedDestinationId
        )
      } else {
        return this.state.destinations.find(d => d.barcode === "gelöscht")
      }
    }

    const detectSourceLocationBarcode = () => {
      if (this.state.selectedSourceLocationId) {
        return stocks.find(
          stock =>
            stock.storage_place.id === this.state.selectedSourceLocationId
        ).storage_place.barcode
      } else {
        const location = stocks.find(
          stock =>
            stock.storage_place && stock.storage_place.type === "Location"
        )
        return location ? location.storage_place.barcode : null
      }
    }

    const onArticleStockOut = destination => {
      if (
        window.confirm(
          this.props.t("articles.detail.stockOutConfirmation", {
            quantity: this.state.quantity || 1,
            productName: product.name,
            destination: getDestination().name
          })
        )
      ) {
        ShelfApi.post("/stock_outs", {
          stock_out: {
            article_barcode: barcode,
            source_location_barcode: detectSourceLocationBarcode(),
            destination: getDestination().barcode,
            quantity: this.state.quantity || 1,
            note: this.state.note
          }
        })
          .then(res => history.push(`/article/${barcode}`))
          .catch(err => alert(err))
      }
    }

    return (
      <div className="sh-detail-view">
        <div className="header">
          <div className="title">
            {this.props.t("articles.detail.stockOutTitle")}
          </div>
        </div>

        <div style={{maxWidth: 550, padding: 25}}>
          {!!!is_singular_item && (
            <Field
              label={this.props.t("articles.detail.quantity")}
              type="text"
              name="quantity"
              value={this.state.quantity}
              onChange={e => {
                const parsedInput = e.target.value
                if (!isNaN(parsedInput) || "" || null) {
                  this.setState({quantity: parsedInput})
                }
              }}
            />
          )}
          {stocks.filter(
            stock =>
              stock.storage_place && stock.storage_place.type === "Location"
          ).length > 1 && (
            <SelectField
              label={this.props.t("articles.detail.sourceLocation")}
              name="source_location"
              options={stocks
                .filter(
                  stock =>
                    stock.storage_place &&
                    stock.storage_place.type === "Location"
                )
                .map(stock => stock.storage_place)}
              onChange={option =>
                this.setState({selectedSourceLocationId: option})
              }
            />
          )}
          {!!stocks.some(
            stock =>
              stock.storage_place && stock.storage_place.type === "Location"
          ) && (
            <SelectField
              label={this.props.t("articles.detail.destination")}
              name="destination"
              options={this.state.destinations}
              onChange={option =>
                this.setState({selectedDestinationId: option})
              }
            />
          )}

          <Field
            label={this.props.t("articles.detail.note")}
            type="textarea"
            name="note"
            value={this.state.note}
            onChange={e => this.setState({note: e.target.value})}
          />
          <div style={{display: "flex", justifyContent: "flex-end"}}>
            <Button
              style={{marginTop: 20, marginRight: 20}}
              secondary
              to={"/article/" + barcode}
              label={this.props.t("cancel")}
            />
            <Button
              style={{marginTop: 20}}
              disabled={!this.state.selectedDestinationId}
              primary
              onClick={() => onArticleStockOut()}
              label={this.props.t("save")}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {
    usingViscosity,
    usingTestDate,
    usingArticleDocuments,
    usingLotNumber
  } = settings
  return {usingViscosity, usingTestDate, usingArticleDocuments, usingLotNumber}
}

export default withTranslation()(connect(mapStateToProps)(ArticleStockOutView))



// WEBPACK FOOTER //
// ./src/views/detail/ArticleStockOutView.js